<h1 mat-dialog-title>
  <ng-container [ngSwitch]="context">
    <ng-container *ngSwitchCase="'option'">{{ 'selectGearDialog.header.option' | translate }}</ng-container>
    <ng-container *ngSwitchCase="'data'">{{ 'selectGearDialog.header.utility' | translate }}</ng-container>
    <ng-container *ngSwitchCase="'analysis'">{{ 'selectGearDialog.header.analysis' | translate }}</ng-container>
    <ng-container *ngSwitchDefault>{{ 'selectGearDialog.header.other' | translate }}</ng-container>
  </ng-container>
</h1>

<button mat-icon-button mat-dialog-close test-id="close-button" class="mat-dialog-close-button">
  <mat-icon>close</mat-icon>
</button>

<div mat-dialog-content>
  <gear-version-selector [isLoading]="isLoading" [gears]="gears" [(context)]="context"
    [formControl]="forms.gearSelection" [disableName]="isEditMode" [disableVersion]="alwaysLatest$ | async">
  </gear-version-selector>

  <ng-container *ngIf="selectedGearId && context !== 'option'">
    <div *ngIf="supportsAlwaysLatest$ | async" class="always-latest">
      <mat-slide-toggle [formControl]="forms.alwaysLatest" test-id="always-latest">
        {{ 'selectGearDialog.alwaysLatest.label' | translate }}
      </mat-slide-toggle>
      <div *ngIf="alwaysLatest$ | async" class="config-info">
        {{ 'selectGearDialog.alwaysLatest.message' | translate }}
      </div>
    </div>

    <div *ngIf="configDiff$ | async as configDiff" class="config-diff">
      <div [innerHTML]="'selectGearDialog.configDiff.info' | translate | interpolate:configDiff.from:configDiff.to | trusthtml"></div>
      <div *ngIf="configDiff.removed.length > 0">
        {{ 'selectGearDialog.configDiff.removed' | translate | interpolate:configDiff.to }} {{ configDiff.removed.join(', ') }}
      </div>
      <div *ngIf="configDiff.added.length > 0">
        {{ 'selectGearDialog.configDiff.added' | translate | interpolate:configDiff.to }} {{ configDiff.added.join(', ') }}
      </div>
    </div>

    <mat-tab-group animationDuration="0ms" mat-stretch-tabs="false" class="tabs-compact tabs-white">
      <mat-tab>
        <ng-template matTabLabel>
          <span test-id="tab-label-configuration">{{ 'selectGearDialog.configuration.tabLabel' | translate }}</span>
          <mat-icon *ngIf="gearConfig?.hasErrors || false" class="flag-icon xs">flag</mat-icon>
        </ng-template>
        <gear-config #gearConfig [config]="unfilteredGears[selectedGearId].gear.config" [formControl]="forms.config" class="tab-content"></gear-config>
      </mat-tab>
      <mat-tab>
        <ng-template matTabLabel>
          <span test-id="tab-label-information">{{ 'selectGearDialog.information.tabLabel' | translate }}</span>
        </ng-template>
        <ng-template matTabContent>
          <gear-info [gear]="unfilteredGears[selectedGearId]" class="tab-content"></gear-info>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </ng-container>
</div>

<div *ngIf="context !== 'option'" mat-dialog-actions align="end">
  <button *ngIf="hasContextOptions" mat-stroked-button test-id="back-button"
    (click)="context = 'option'" class="back-button">
    <mat-icon>chevron_left</mat-icon>
    <span>{{ 'common.actions.back' | translate }}</span>
  </button>
  <button mat-stroked-button mat-dialog-close test-id="close-button">{{ 'common.actions.close' | translate }}</button>
  <button mat-flat-button color="primary" test-id="save-button" [disabled]="!(isValid$ | async)" (click)="saveChanges()">
    {{ 'selectGearDialog.buttons.selectGear' | translate }}
  </button>
</div>
